export default {
  category_name: 'Køb gavekort',
};
